module.exports = __webpack_public_path__ + "img/icons BFr_23.ca4e2411.png";